import styled, { css } from 'styled-components';
import { StyledPopoverContentProps } from './types';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledPopoverContent = styled.div<StyledPopoverContentProps>`
  ${({ display }) => (display ? `display: ${display};` : '')}
  font-family: var(--redsift-typography-body-font-family);
  font-size: var(--redsift-typography-body-font-size);
  font-weight: var(--redsift-typography-body-font-weight);
  line-height: 20px;

  ${({ padding, paddingBottom, paddingLeft, paddingRight, paddingTop }) =>
    css`
      ${padding ? `padding: ${padding};` : ''}
      ${paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}
      ${paddingLeft ? `padding-left: ${paddingLeft};` : ''}
      ${paddingRight ? `padding-right: ${paddingRight};` : ''}
      ${paddingTop ? `padding-top: ${paddingTop};` : ''}
    `}
  ${({ padding, paddingBottom, paddingLeft, paddingRight, paddingTop }) =>
    css`
      ${padding ? `padding: ${padding};` : ''}
      ${paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}
      ${paddingLeft ? `padding-left: ${paddingLeft};` : ''}
      ${paddingRight ? `padding-right: ${paddingRight};` : ''}
      ${paddingTop ? `padding-top: ${paddingTop};` : ''}
    `}
  ${({ height, maxHeight, maxWidth, minHeight, minWidth, width }) =>
    css`
      ${height !== undefined ? `height: ${typeof height === 'number' ? `${height}px` : height};` : ''}
      ${maxHeight ? `max-height: ${maxHeight};` : ''}
      ${maxWidth ? `max-width: ${maxWidth};` : ''}
      ${minHeight ? `min-height: ${minHeight};` : ''}
      ${minWidth ? `min-width: ${minWidth};` : ''}
      ${width !== undefined ? `width: ${typeof width === 'number' ? `${width}px` : width};` : ''}
    `}
  ${({ position, top, bottom, left, right, zIndex }) =>
    css`
      ${position ? `position: ${position};` : ''}
      ${top ? `top: ${top};` : ''}
      ${bottom ? `bottom: ${bottom};` : ''}
      ${left ? `left: ${left};` : ''}
      ${right ? `right: ${right};` : ''}
      ${zIndex ? `z-index: ${zIndex};` : ''}
    `}
  ${({
    alignContent,
    alignItems,
    gap,
    gridAutoColumns,
    gridAutoRows,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    justifyContent,
    justifyItems,
  }) =>
    css`
      ${alignContent ? `align-content: ${alignContent};` : ''}
      ${alignItems ? `align-items: ${alignItems};` : ''}
      ${gap ? `gap: ${gap};` : ''}
      ${gridAutoColumns ? `grid-auto-columns: ${gridAutoColumns};` : ''}
      ${gridAutoRows ? `grid-auto-rows: ${gridAutoRows};` : ''}
      ${gridTemplateAreas ? `grid-template-areas: ${gridTemplateAreas};` : ''}
      ${gridTemplateColumns ? `grid-template-columns: ${gridTemplateColumns};` : ''}
      ${gridTemplateRows ? `grid-template-rows: ${gridTemplateRows};` : ''}
      ${justifyContent ? `justify-content: ${justifyContent};` : ''}
      ${justifyItems ? `justify-items: ${justifyItems};` : ''}
    `}
  ${({ alignContent, alignItems, flexDirection, flexWrap, gap, justifyContent }) =>
    css`
      ${alignContent ? `align-content: ${alignContent};` : ''}
      ${alignItems ? `align-items: ${alignItems};` : ''}
      ${flexDirection ? `flex-direction: ${flexDirection};` : ''}
      ${flexWrap ? `flex-wrap: ${flexWrap};` : ''}
      gap: ${gap};
      ${justifyContent ? `justify-content: ${justifyContent};` : ''}
    `}

  ${({ $theme }) => css`
    color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    background-color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'black' : 'white'});
  `}

  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  font-family: var(--redsift-typography-body-font-family);
  font-size: var(--redsift-typography-body-font-size);
  font-weight: var(--redsift-typography-body-font-weight);
  line-height: 20px;
  max-width: calc(100vw - 48px);
  overflow: auto;
  z-index: var(--redsift-layout-z-index-popover);

  &:focus-visible {
    outline: none;
  }
`;
